import dayjs from 'dayjs'
import { FunctionField, RaRecord, useLocaleState } from 'react-admin'
import { DateFieldProps } from './type'

export const DateField: React.FC<DateFieldProps> = ({
  format = 'DD/MM/YYYY',
  source,
  showTime = false,
  ...props
}) => {
  const [activeLocale] = useLocaleState()
  const render = (record: RaRecord): string => {
    if (!record || !record[source]) return null
    const date = dayjs(record[source])
    return activeLocale === 'th'
      ? date
          .add(543, 'year')
          .locale('th')
          .format(showTime ? `${format}, HH:mm:ss น.` : format)
      : date.format(showTime ? `${format}, HH:mm:ss A` : format)
  }
  return <FunctionField render={render} {...props} />
}
